<ion-header mode="ios" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tabs/home" text=""></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="campaign" class="ion-padding promo-campaign" scrollY="true">
  <div class="image-container spacer">
    <img
      *ngIf="campaign.attributes.image"
      [src]="campaign.attributes.image"
      title="{{campaign.attributes.name}}"
      alt="{{campaign.attributes.name}}"
    />
  </div>
  <app-remaining-time-label [start]="campaign.attributes.start_date" [end]="campaign.attributes.end_date"></app-remaining-time-label>
  <div class="spacer">
    <h1 class="ds-title-3">{{ 'PROMO.mainOffer' | translate: { amount: highestAmount | thousand: currentAccount.currency } }}</h1>
    <p class="ds-running-1">{{campaign.attributes.description}}</p>
  </div>

  <h2 class="ds-heading-2">{{ 'PROMO.rewards.label' | translate}}</h2>
  <div class="spacer">
    <div class="promo-banner" *ngFor="let promo of campaign.promotions;">
      <app-ds-rounded-icon icon="gift" variant="custom" customColor="var(--color-core-brand-1-5)" color="var(--color-core-neutral-0)"></app-ds-rounded-icon>
      <div class="promo-info">
        <h3 class="ds-heading-3">
          {{ 'PROMO.depositOffer' | translate: { amount: promo.attributes.deposit_target | thousand: currentAccount.currency, award:
          promo.attributes.value | thousand: currentAccount.currency } }}
        </h3>
        <div class="ds-caption-3 ds-color-core-neutral-7">
          {{ 'PROMO.depositOfferConditions' | translate: { award: promo.attributes.value / promo.attributes.months_distribution_no |
          thousand: currentAccount.currency , month: promo.attributes.months_distribution_no } }}
        </div>
      </div>
    </div>
  </div>

  <h2 class="ds-heading-2">{{ 'PROMO.howTo.label' | translate}}</h2>
  <div class="spacer">
    <div class="step">
      <app-ds-rounded-icon
        class="campaign-icon"
        icon="pointer"
        variant="custom"
        customColor="var(--color-core-brand-2-2)"
      ></app-ds-rounded-icon>
      <div>
        <h3 class="ds-heading-3">{{ 'PROMO.howTo.step1.name' | translate}}</h3>
        <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'PROMO.howTo.step1.description' | translate}}</p>
      </div>
    </div>
    <div class="step">
      <app-ds-rounded-icon
        class="campaign-icon"
        icon="square-arrow-down"
        variant="custom"
        customColor="var(--color-core-brand-6-2)"
      ></app-ds-rounded-icon>
      <div>
        <h3 class="ds-heading-3">{{ 'PROMO.howTo.step2.name' | translate}}</h3>
        <p class="ds-ui-2 ds-color-core-neutral-8" [innerHTML]="'PROMO.howTo.step2.description' | translate: { date: endDate}"></p>
      </div>
    </div>
    <div class="step">
      <app-ds-rounded-icon
        class="campaign-icon"
        icon="gift"
        variant="custom"
        customColor="var(--color-core-brand-4-3)"
      ></app-ds-rounded-icon>
      <div>
        <h3 class="ds-heading-3">{{ 'PROMO.howTo.step3.name' | translate}}</h3>
        <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'PROMO.howTo.step3.description' | translate}}</p>
      </div>
    </div>
  </div>
  <div class="participation spacer">
    <ng-container *ngIf="!campaign.attributes.opted_in; else alreadyParticipating">
      <app-ds-button (clicked)="participate(true)">{{'PROMO.CTA.label' | translate}}</app-ds-button>
    </ng-container>
    <ng-template #alreadyParticipating>
      <p class="ds-heading-1">{{ 'PROMO.statusParticipating' | translate}}</p>
    </ng-template>
  </div>

  <div *ngIf="campaign.attributes.tnc_link" class="tnc" target="_blank">
    <a class="ds-ui-2 ds-color-core-neutral-9" href="{{campaign.attributes.tnc_link}}" target="_blank">
      {{ 'PROMO.termsAndConditions' | translate}}
    </a>
  </div>
</ion-content>
